import {CordovaService,} from './CordovaService';
import {Camera, CameraDirection, CameraResultType, CameraSource, ImageOptions, Photo} from '@capacitor/camera';

export class CameraService {

  static $inject = [
    CordovaService.serviceId,
  ];
  static serviceId = 'camera';

  static MaxWidth = 1024;
  static MaxHeight = 1920;

  constructor(private cordova: CordovaService) {

  }

  albumPicture(): Promise<Photo> {
    return Camera.getPhoto({
      source: CameraSource.Photos,
      promptLabelCancel: 'Abbrechen',
      promptLabelPicture: 'Aufnehmen',
      resultType: CameraResultType.Base64,
      quality: 70,
    });
  }

  takePicture(): Promise<Photo> {
    let config: ImageOptions = {
      source: CameraSource.Camera,
      promptLabelCancel: 'Abbrechen',
      promptLabelPicture: 'Aufnehmen',
      resultType: CameraResultType.Base64,
      presentationStyle: 'fullscreen',
      quality: 70,
    };
    if (this.cordova.isTablet) {
      config.direction = CameraDirection.Front;
    }
    return Camera.getPhoto(config);
  }
}
